import { put } from 'redux-saga/effects';
import { setLive } from '../actions';

/**
 * @typedef {object} UpdateLiveAction
 * @property {string} type
 * @property {object} payload
 * @property {boolean} payload.isActive
 */

/**
 * @param {UpdateLiveAction} action - The Redux action.
 */
export function* updateLive(action) {
    yield put(setLive(action.payload));
}
